import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02cb21e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = { class: "title text-left pb-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_6 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_8 = {
  id: "example",
  class: "stripe hover",
  style: {"width":"100%","padding-top":"1em","padding-bottom":"1em"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "1"
    }, "Nome"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "E-mail"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Telefone"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Perfil"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "3"
    }, " ")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Matheus Amaral da Silva", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "matheus.silva@tecnospeed.com.br", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "(44) 99770-3466", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Administrador", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ativo", -1))
const _hoisted_16 = { class: "flex gap-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Raul Neto", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "raul.neto@tecnospeed.com.br", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "(44) 99770-3466", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Administrador", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Validação pendente", -1))
const _hoisted_22 = { class: "flex gap-5" }
const _hoisted_23 = { class: "py-8 pt-3 w-full" }
const _hoisted_24 = { class: "lg:flex gap-5 w-full" }
const _hoisted_25 = { class: "block md:flex gap-5 w-full" }
const _hoisted_26 = { class: "block md:flex gap-5 w-full" }
const _hoisted_27 = { class: "w-6/6 md:w-3/6" }
const _hoisted_28 = { class: "gap-5 flex" }
const _hoisted_29 = { class: "w-full flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.registering ? 'Novo Usuário' : 'Usuários'), 1),
      (!_ctx.registering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15,
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_FontAwesomeIcon, {
                              class: "text-yellow-300 cursor-pointer",
                              icon: _ctx.pen
                            }, null, 8, ["icon"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_FontAwesomeIcon, {
                              class: "text-red-500 cursor-pointer",
                              icon: _ctx.trash
                            }, null, 8, ["icon"])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_17,
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_FontAwesomeIcon, {
                              class: "text-yellow-300 cursor-pointer",
                              icon: _ctx.pen
                            }, null, 8, ["icon"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_FontAwesomeIcon, {
                              class: "text-red-500 cursor-pointer",
                              icon: _ctx.trash
                            }, null, 8, ["icon"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.registering)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "pt-8 px-6 m-5 mx-auto",
            orientation: "flex-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Input, {
                      label: "Nome",
                      class: "w-6/6 md:w-3/6",
                      incorrectMessage: _ctx.validations.nome,
                      isIncorrect: _ctx.validations.nome != '',
                      labelClass: "p-0 text-left",
                      modelValue: _ctx.user.nome,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.nome) = $event))
                    }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                    _createVNode(_component_Input, {
                      label: "E-mail",
                      class: "w-6/6 md:w-3/6",
                      incorrectMessage: _ctx.validations.email,
                      isIncorrect: _ctx.validations.email != '',
                      labelClass: "p-0 text-left",
                      modelValue: _ctx.user.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.email) = $event))
                    }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Input, {
                      label: "Telefone",
                      mask: ['(##) ####-####', '(##) #####-####'],
                      class: "w-6/6 md:w-3/6",
                      incorrectMessage: _ctx.validations.celular,
                      isIncorrect: _ctx.validations.celular != '',
                      labelClass: "p-0 text-left",
                      modelValue: _ctx.user.celular,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.celular) = $event))
                    }, null, 8, ["mask", "incorrectMessage", "isIncorrect", "modelValue"]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Select, {
                        label: "Perfil de Acesso",
                        slected: _ctx.user ? _ctx.user.tipo : null,
                        display: "label",
                        options: () => [{label: 'Técnico'}, {label: 'Administrador'}, {label: 'Financeiro'}],
                        labelClass: "p-0 text-left",
                        event: "update:editValue",
                        class: "w-fill",
                        incorrectMessage: _ctx.validations.tipo,
                        isIncorrect: _ctx.validations.tipo != '',
                        "onUpdate:editValue": _ctx.changeTypeFilter
                      }, null, 8, ["slected", "options", "incorrectMessage", "isIncorrect", "onUpdate:editValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Button, {
                    label: "Voltar",
                    onClick: _ctx.back,
                    class: "ml-auto p-0 my-4 divide-transparent",
                    width: "w-min"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_PrimaryButton, {
                    isLoading: _ctx.loading,
                    label: "Enviar",
                    onClick: _ctx.send,
                    class: "p-0 my-4 divide-transparent text-white",
                    type: "submit"
                  }, null, 8, ["isLoading", "onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        (!_ctx.registering)
          ? (_openBlock(), _createBlock(_component_PrimaryButton, {
              key: 0,
              isLoading: _ctx.loading,
              label: "Novo Usuário",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.registering = true)),
              class: "ml-auto mt-5 divide-transparent text-white"
            }, null, 8, ["isLoading"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Toast, {
        label: _ctx.message,
        hidden: _ctx.hidden,
        onHide: _ctx.hide
      }, null, 8, ["label", "hidden", "onHide"])
    ])
  ]))
}